import { DataObject } from "../core/data/DataObject";
/**
 * GetSettingsParams.ts
 */
export class GetSettingsParams {
    constructor(roomName) {
        this.roomName = roomName;
    }
    liquify() {
        return new DataObject(this);
    }
}
//# sourceMappingURL=GetSettingsParams.js.map